module.exports = __webpack_public_path__ + "05_long_grey.2b7f278c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_long_grey.png
// module id = 1haZ
// module chunks = 0